<template>
  <v-app>
    <v-main>
      <RegistrationStart />
    </v-main>
  </v-app>
</template>

<script>
import RegistrationStart from "./components/RegistrationStart.vue";

export default {
  name: "App",
  components: {
    RegistrationStart,
  },
  mounted() {
    if (this.$store.getters["registration/locale"]) {
      document.documentElement.lang = this.$store.getters["registration/locale"];
    }
  },
};
</script>
